import crudDataTable from './crudDataTable.vue'
export default crudDataTable
